Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
exports.colors = {
  primary: "primary",
  secondary: "secondary",
  light: "light"
};
exports.default = exports.colors;